/*
 * @Author: 肖玲
 * @Date: 2023-02-23 18:17:41
 * @LastEditTime: 2023-02-24 13:49:08
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\earlywarning-manage\early-warning-platform\index.js
 * 预警平台
 */
import earlywarningInformationManageRouter from "./modules/earlywarningInformationManageRouter";
import systemSettingsRouter from './modules/systemSettingsRouter'
const earlyWarningPlatformRouter = [].concat(
  earlywarningInformationManageRouter,
  systemSettingsRouter
)
export default earlyWarningPlatformRouter